import { default as _91_46_46_46route_93reNw4psOiuMeta } from "/builds/webcontact/engelsbrand/pages/[...route].vue?macro=true";
import { default as exampleaC5hgHXijXMeta } from "/builds/webcontact/engelsbrand/pages/example.vue?macro=true";
import { default as indexr63NH8iDsTMeta } from "/builds/webcontact/engelsbrand/pages/index.vue?macro=true";
export default [
  {
    name: "route",
    path: "/:route(.*)*",
    component: () => import("/builds/webcontact/engelsbrand/pages/[...route].vue")
  },
  {
    name: "example",
    path: "/example",
    component: () => import("/builds/webcontact/engelsbrand/pages/example.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/webcontact/engelsbrand/pages/index.vue")
  }
]